/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import i18next from 'i18next';

export const ProcedureCategory = {
  NATIONAL_PROCEDURE: 'national-procedure',
  WIPO_PROCEDURE: 'wipo-procedure',
  EP_PROCEDURE: 'epo-procedure',
  EP_VALIDATION_PROCEDURE: 'ep-validation-procedure',
  SPC_PROCEDURE: 'spc-procedure',
  SUBSEQUENT_ACTIONS: 'subsequent-actions-procedure',
};

export const getProcedureName = (submission) => {
  const procedure = submission?.procedure;

  return i18next.t(procedure, procedure);
};
